import React from 'react';
import { getDateInputValue, getTimeInputValue, getTodayDateString, getCurrentTimeString } from '../utils';

type Props = {
  label: string;
  value: Date;
  onDateChange: (dateString: string) => void;
  onTimeChange: (timeString: string) => void;
};

export const DateTimeInput = ({ label, value, onDateChange, onTimeChange }: Props) => {
  const today = getTodayDateString();
  const selectedDate = getDateInputValue(value);
  const isToday = selectedDate === today;
  
  // スクロールイベントを防ぐハンドラー
  const handleWheelPrevent = (e: React.WheelEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.currentTarget.blur();
  };

  // キーボードでの値変更を制御
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // 上下矢印キーでの値変更を防ぐ
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    }
  };

  return (
    <div className="flex items-center gap-[16px]">
      <label className="text-[14px] text-primary noto-sans-jp-medium">
        {label}
      </label>
      <div className="flex items-center gap-[8px]">
        <input
          type="date"
          value={getDateInputValue(value)}
          onChange={(e) => onDateChange(e.target.value)}
          onWheel={handleWheelPrevent}
          onKeyDown={handleKeyDown}
          min={today}
          className="border border-gray-300 rounded-[6px] px-[8px] py-[4px] text-[12px] noto-sans-jp-regular"
          style={{ 
            MozAppearance: 'textfield',
            WebkitAppearance: 'none'
          }}
        />
        <input
          type="time"
          value={getTimeInputValue(value)}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (inputValue) {
              onTimeChange(inputValue);
            }
          }}
          onWheel={handleWheelPrevent}
          onKeyDown={handleKeyDown}
          min={isToday ? getCurrentTimeString() : undefined}
          className="border border-gray-300 rounded-[6px] px-[8px] py-[4px] text-[12px] noto-sans-jp-regular text-center"
          style={{ 
            MozAppearance: 'textfield',
            WebkitAppearance: 'none',
            width: '80px'
          }}
        />
        <span className="text-[12px] text-textSecondary noto-sans-jp-regular">
          まで
        </span>
      </div>
    </div>
  );
}; 